( function ( $ ) {
	// estimate form

	if ( $( '#form-1' ).length > 0 ) {
		$( '.datepicker' ).datepicker();

		$( '#phone, #zip1, #zip2' ).on( 'keypress', function ( event ) {
			event = event || window.event;
			if ( event.charCode && event.charCode !== 0 && event.charCode !== 46 && ( event.charCode < 48 || event.charCode > 57 ) ) {
				return false;
			}
		} );

		const target = document.getElementById( 'estimate-type-size' );
		const observer = new MutationObserver( function ( mutations ) {
			mutations.forEach( function ( mutation ) {
				const elevatorWrap = document.getElementById( 'elevator-wrap' );
				const elevatorVal = document.getElementById( 'elevator-val' );
				if ( ! mutation.target.defaultValue.match( /apartment/ ) ) {
					elevatorWrap.classList.add( 'disabled-app' );
					elevatorVal.value = '';
				} else if ( mutation.target.defaultValue.match( /apartment/ ) ) {
					elevatorWrap.classList.remove( 'disabled-app' );
				}
			} );
		} );

		var config = { attributes: true, childList: true, characterData: true };
		observer.observe( target, config );

		const requiredQuestion3 = () => {
			const sendB = document.getElementById( 'form-button' );
			const target1 = document.getElementById( 'estimate-type-size' );
			const reqSelect = document.getElementById( 'residence_select' );
			const target2 = document.getElementById( 'elevator-val' );
			const reqSelect2 = document.getElementById( 'elevator-select' );
			const target3 = document.getElementById( 'elevator-to-val' );
			const reqSelect3 = document.getElementById( 'elevator-to_select' );
			sendB.onclick = function () {
				if ( ! target1.value ) {
					reqSelect.style.border = '1px solid red';
					document.getElementById( 'select_alert1' ).textContent = 'Select type&size of residence!';
				}
				if ( ! target2.value ) {
					reqSelect2.style.border = '1px solid red';
					document.getElementById( 'select_alert2' ).textContent = 'Select is there an elevator!';
				}
				if ( ! target3.value ) {
					reqSelect3.style.border = '1px solid red';
					document.getElementById( 'select_alert3' ).textContent = 'Select is there an elevator!';
				}
			};
			let observer1 = new MutationObserver( function ( mutations ) {
				mutations.forEach( function ( mutation ) {
					if ( target.value !== '' ) {
						reqSelect.style.border = '1px solid #A3ACC2';
						document.getElementById( 'select_alert1' ).textContent = '';
					}
				} );
			} );
			let observer2 = new MutationObserver( function ( mutations ) {
				mutations.forEach( function ( mutation ) {
					if ( target2.value !== '' ) {
						reqSelect2.style.border = '1px solid #A3ACC2';
						document.getElementById( 'select_alert2' ).textContent = '';
					}
				} );
			} );
			let observer3 = new MutationObserver( function ( mutations ) {
				mutations.forEach( function ( mutation ) {
					if ( target3.value !== '' ) {
						reqSelect3.style.border = '1px solid #A3ACC2';
						document.getElementById( 'select_alert3' ).textContent = '';
					}
				} );
			} );

			var config = {
				attributes: true,
				childList: true,
				characterData: true,
			};

			observer1.observe( target, config );

			var config2 = {
				attributes: true,
				childList: true,
				characterData: true,
			};

			observer2.observe( target2, config );

			var config3 = {
				attributes: true,
				childList: true,
				characterData: true,
			};

			observer3.observe( target3, config );
		};
		requiredQuestion3();

		const clearForm = () => {
			const resetButton = document.getElementById( 'btn-reset' );
			resetButton.onclick = function () {
				document.getElementById( 'form-1' ).reset();
			};
		};
		clearForm();

		const formph = $( '#form-1' );
		formph.validate( {
			submitHandler( formph ) {
				$( '#form-1 .form-send' ).attr( 'disabled', true );
				const fd = new FormData( formph );
				$.ajax( {
					async: true,
					url: '/wp-admin/admin-ajax.php',
					type: 'POST',
					data: fd,
					cache: false,
					contentType: false,
					processData: false,
					success( data ) {
						$( '#form-1 .form-send' ).attr( 'disabled', false );

						const response = JSON.parse( data );
						// console.log( response.leadId );
						window.dataLayer = window.dataLayer || [];
						dataLayer.push( {
							event: 'new_lead_created',
							leadId: response.leadId,
						} );

						window.location.href = '/success';
					},
					error( data ) {
						console.log( 'error' );
						console.log( data );
					},
				} );
				return false;
			},
			rules: {
				estimate_name: {
					required: true,
				},
				estimate_tel: {
					required: true,
				},
				estimate_email: {
					required: true,
				},
				estimate_date: {
					required: true,
				},
				estimate_city_from: {
					required: true,
				},
				estimate_street_from: {
					required: true,
				},
				estimate_zip_code_from: {
					required: true,
				},
				estimate_floor_from: {
					required: true,
				},
				estimate_city_to: {
					required: true,
				},
				estimate_street_to: {
					required: true,
				},
				estimate_zip_cod_to: {
					required: true,
				},
				estimate_floor: {
					required: true,
				},
				estimate_biggest_heaviest: {
					required: true,
				},
			},
			messages: {
				estimate_name: {
					required: 'Enter name!',
				},
				estimate_tel: {
					required: 'Enter phone!',
					minlength: 'Phone must contain 10 digits!',
				},
				estimate_date: {
					required: 'Enter date!',
				},
				estimate_city_from: {
					required: 'Enter city!',
				},
				estimate_street_from: {
					required: 'Enter street address!',
				},
				estimate_zip_code_from: {
					required: 'Enter zip code!',
					minlength: 'Zip code must contain 5 digits!',
				},
				estimate_floor_from: {
					required: 'Enter floor moving!',
				},
				estimate_city_to: {
					required: 'Enter city!',
				},
				estimate_street_to: {
					required: 'Enter street address!',
				},
				estimate_zip_code_to: {
					required: 'Enter zip code!',
					minlength: 'Zip code must contain 5 digits!',
				},
				estimate_floor: {
					required: 'Enter floor!',
				},
				estimate_email: {
					required: 'Email must be in the format name@domain.com!',
				},
				estimate_biggest_heaviest: {
					required: 'Enter biggest/haviest items',
				},
			},
			errorElement: 'div',
			focusInvalid: true,
			errorClass: 'input_error',
		} );
	}

	//Select -> Options JS
	$( '.select' ).on( 'click', '.select__head', function () {
		if ( $( this ).hasClass( 'open' ) ) {
			$( this ).removeClass( 'open' );
			$( this ).next().fadeOut();
		} else {
			$( '.select__head' ).removeClass( 'open' );
			$( '.select__list' ).fadeOut();
			$( this ).addClass( 'open' );
			$( this ).next().fadeIn();
		}
	} );

	$( '.select' ).on( 'click', '.select__item', function () {
		$( this ).parent().prev().addClass( 'has-value' );
		$( '.select__head' ).removeClass( 'open' );
		$( this ).parent().fadeOut();
		$( this ).parent().prev().text( $( this ).text() );
		$( this ).parent().prev().prev().val( $( this ).text() );
	} );

	$( document ).on( 'click', function ( e ) {
		if ( ! $( e.target ).closest( '.select' ).length ) {
			$( '.select__head' ).removeClass( 'open' );
			$( '.select__list' ).fadeOut();
		}
	} );
} )( jQuery );
